<template>
  <div class="scs-image-input">
    <h5 v-if="heading">{{ heading }}</h5>
    <div class="scs-image">
      <round-button-with-icon
        class="edit-pen"
        icon="pencil"
        @click="chooseFile"
      />
      <div
        class="scs-image-display"
        :style="{ 'background-image': 'url(' + getURL() + ')' }"
      />
      <input
        type="file"
        accept="image/*"
        id="scs-image-hidden-file-button"
        @change="onFileChange"
      />
    </div>
  </div>
</template>
<script>
import RoundButtonWithIcon from "../UI/RoundButtonWithIcon.vue";
export default {
  data() {
    return {
      loading: false,
      photoFile: undefined,
    };
  },
  methods: {
    chooseFile() {
      this.loading = true;
      document.getElementById("scs-image-hidden-file-button").click();
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.photoFile = files[0];
      this.$emit("scs-input", this.photoFile);
    },
    getURL() {
      if (this.photoFile) {
        return URL.createObjectURL(this.photoFile);
      } else if (this.initial) {
        return this.initial;
      } else {
        return "@/src/assets/spin-logo-with-text.png";
      }
    },
  },
  components: {
    RoundButtonWithIcon,
  },
  emits: ["scs-input"],
  props: ["initial", "heading", "processing"],
};
</script>
<style scoped>
.scs-image-input {
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;

  position: relative;
}
#scs-image-hidden-file-button {
  display: none;
}

h5 {
  margin: 15px 0;
}

.scs-image-display {
  height: 70px;
  width: 70px;
  min-height: 70px;
  min-width: 70px;
  border-radius: 35px;
  max-width: 70px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-color: var(--secondaryColor);
}

.edit-pen {
  position: absolute;
  right: -6px;
  bottom: -6px;
  background-color: var(--backgroundColor);
  filter: drop-shadow(0px 0px 2px var(--shadow));
  z-index: 2;
}
</style>
